import { useScreenSize } from '@/hooks/useScreenSize';
import { useConfigStore } from '@/stores';
import type { SVGProps } from 'react';

type Props = SVGProps<SVGSVGElement> & {
    color?: string;
};

export const PaperIcon = (props: Props) => {
    const { color: colorProp, width = 32, height = 32, ...rest } = props;
    const contrast = useConfigStore((state) => state.config.ui.contrast);
    const color = colorProp ?? (contrast ? 'black' : 'white');

    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    const numericWidth = typeof width === 'string' ? parseFloat(width) : width;
    const numericHeight = typeof height === 'string' ? parseFloat(height) : height;

    return (
        <svg
            width={scaleWidthPixel(numericWidth)}
            height={scaleHeightPixel(numericHeight)}
            viewBox="0 0 32 32"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...rest}
        >
            <path d="M22 23V5H6V22.28H19.6" stroke={color} strokeWidth="1.5" />

            <rect x="10" y="9.75" width="8" height="1.5" fill={color} />

            <rect x="10" y="13.25" width="8" height="1.5" fill={color} />

            <rect x="10" y="16.75" width="8" height="1.5" fill={color} />
        </svg>
    );
};
